<template>
    <div class="field has-addons" style="padding-right: 15px;">
        <div class="control">
            <input class="input" v-on:change="bidResult()" type="number" placeholder="Result" v-model="currentBid.result">
        </div>
        <p class="control">
            <a class="button is-static">
                000 ¥
            </a>
        </p>
    </div>
</template>

<script>
    import apiBids from '../../../../api/apiBids'
    export default {
        props: ['bid'],
        data() {
            return {
                isLoading: false,
                currentBid: {
                    id: this.bid.id,
                    result: ''
                }
            }
        },
        methods: {
            bidResult() {
                this.isLoading = true
                apiBids
                    .updateBidRequest(this.currentBid)
                    .then((response) => {
                        this.bid.result = this.currentBid.result
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Card/Buttons/Bids/BidResult.vue